export const environment = {
	production: true,
	API_BASE_URL: 'https://rails-api-qa.azurewebsites.net',
	apiUrl: 'https://rails-api-qa.azurewebsites.net/api/',
	adminUrl: 'https://rails-admin-qa.azurewebsites.net',
	whiteListedEndpoints: ['rails-api-qa.azurewebsites.net'],
	activeDirectoryOptions: {
		clientId: '8a878cdd-dd45-4193-bce5-ee1d2001925f',
		redirectUri: window.location.origin,
		instance: 'https://login.microsoftonline.com/',
		tenant: '5384b56e-74f5-4534-b967-074c24d7d2f6' || 'railpros.com',
		postLogoutRedirectUri: 'http://rails-admin-qa.azurewebsites.net',
		cacheLocation: 'localStorage',
		scopes: [
			'https://railpros.com/be3a2360-ad91-40eb-811b-a5ce992fadf1/user_impersonation',
		],
	},
	appVersion: require('../../package.json').version,
	googleAnalyticsCode: 'UA-142492767-3',
};
